var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0B1548"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0199 25.2846L14.0629 26.9799L11.0946 25.2893L11.0863 14.719L14.0589 13.0168L22.9602 18.1068L22.9519 14.7107L25.9328 13.0002L28.9137 14.7107V25.2727L25.9162 26.9998L22.9685 25.3059V21.5112L19.9959 23.2134L17.0199 21.5278V25.2846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.c783a062b35421506271e016466c18f3.svg";
export { ForwardRef as ReactComponent };